import React from "react";

const HeaderSliderButton = () => {
  const handleScrollDown = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };
  return (
    <button
      type="button"
      className="flex absolute z-[5] lg:bottom-9 bottom-2 left-1/2 -translate-x-1/2 button-hover"
      aria-label="Scroll down"
      onClick={handleScrollDown}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 30C18.6522 30 21.1957 28.9464 23.0711 27.0711C24.9464 25.1957 26 22.6522 26 20V12C26 9.34784 24.9464 6.8043 23.0711 4.92893C21.1957 3.05357 18.6522 2 16 2C13.3478 2 10.8043 3.05357 8.92893 4.92893C7.05357 6.8043 6 9.34784 6 12V20C6 22.6522 7.05357 25.1957 8.92893 27.0711C10.8043 28.9464 13.3478 30 16 30ZM8 12C8 9.87827 8.84285 7.84344 10.3431 6.34315C11.8434 4.84285 13.8783 4 16 4C18.1217 4 20.1566 4.84285 21.6569 6.34315C23.1571 7.84344 24 9.87827 24 12V20C24 22.1217 23.1571 24.1566 21.6569 25.6569C20.1566 27.1571 18.1217 28 16 28C13.8783 28 11.8434 27.1571 10.3431 25.6569C8.84285 24.1566 8 22.1217 8 20V12Z"
          fill="white"
          className="button-background"
        />
        <path
          d="M16 12C16.2652 12 16.5196 11.8946 16.7071 11.7071C16.8946 11.5196 17 11.2652 17 11V7C17 6.73478 16.8946 6.48043 16.7071 6.29289C16.5196 6.10536 16.2652 6 16 6C15.7348 6 15.4804 6.10536 15.2929 6.29289C15.1054 6.48043 15 6.73478 15 7V11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4804 11.8946 15.7348 12 16 12Z"
          fill="white"
          className="bounce"
        />
      </svg>
    </button>
  );
};

export default HeaderSliderButton;
